import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-step-progress-indicator',
  templateUrl: './step-progress-indicator.component.html',
  styleUrls: ['./step-progress-indicator.component.css']
})
export class StepProgressIndicatorComponent {
  @Input() currentStep: number;
  @Input() totalSteps: number;
}
